// extracted by mini-css-extract-plugin
export default {"container":"styles_container__umSjZ","ball":"styles_ball__fveEQ","jump":"styles_jump__xMZX2"};